"use-client";
import Head from "next/head";
import PricingPersonal from "./pricing-personal";
import PricingBusiness from "./pricing-business";
import ToggleButton from "src/components/general/toggleButton";
import { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";

const toggleValue = [
  {
    text: "Personal",
    value: "Personal",
    imageSource: "/images/pricing/tab/personalTabIcon.svg",
    selectedImageSource: "/images/pricing/tab/personalTabIconSelected.svg",
  },
  {
    text: "Business",
    value: "Business",
    imageSource: "/images/pricing/tab/businessTabIcon.svg",
    selectedImageSource: "/images/pricing/tab/businessTabIconSelected.svg",
  },
];

const PricingNew = () => {
  const searchParams = useSearchParams();
  const [tabToggleValue, SetTabToggleValues] = useState("Personal");

  useEffect(() => {
    const page = searchParams.get("page");
    if (page) {
      handleTabToggleChange(page);
    } else {
      handleTabToggleChange("Personal");
    }
  }, [searchParams]);

  const handleTabToggleChange = (value) => {
    SetTabToggleValues(value);
  };

  return (
    <>
      <Head>
        <title>Redact - Premium</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Redact is a service that can easily mass delete your messages, posts, and comments on Twitter, Reddit, Discord, Facebook, and more."
        />
        <meta name="keywords" content="redact mass delete privacy free" />

        <meta property="og:title" content="Mass delete your tweets posts & DMs on 30+ sites" />
        <meta
          property="og:description"
          content="Mass delete your messages, posts and comments on Twitter, Reddit, Discord, Facebook, and more, all from one free app."
        />

        <meta property="og:url" content="https://www.redact.dev" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <div className="bg-brand-slate/40 h-[1px] w-full mt-16 sm:mt-0 sm:mb-1" />
      <ToggleButton
        ToggleValues={toggleValue}
        DefaultValue={tabToggleValue}
        isTransparent={true}
        OnValueChange={handleTabToggleChange}
        buttonColor="data-[state=on]:text-brand-blue w-[120px]"
      />
      <div className="bg-brand-slate/40 h-[1px] w-full mt-0" />
      {tabToggleValue === "Personal" ? <PricingPersonal /> : <PricingBusiness />}
    </>
  );
};

export default PricingNew;
